import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(".unpermitted-dropdown").each((i,el) => {
      el.classList.add("disabled");  
      el.setAttribute("data-toggle","tooltip");
      el.setAttribute("data-title","Access restricted by User role.");
      el.style["pointer-events"] = "auto";
    });
  } 
}
